var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#1C2743",
    d: "m13.75,1.5c0,-0.69036 0.5596,-1.25 1.25,-1.25l2.5,0c0.6904,0 1.25,0.55965 1.25,1.25l0,15l0.625,0c0.3452,0 0.625,0.2798 0.625,0.625c0,0.3452 -0.2798,0.625 -0.625,0.625l-18.75,0c-0.34518,0 -0.625,-0.2798 -0.625,-0.625c0,-0.3452 0.27982,-0.625 0.625,-0.625l0.625,0l0,-3.75c0,-0.6904 0.55964,-1.25 1.25,-1.25l2.5,0c0.69036,0 1.25,0.5596 1.25,1.25l0,3.75l1.25,0l0,-8.75c0,-0.69036 0.55964,-1.25 1.25,-1.25l2.5,0c0.6904,0 1.25,0.55964 1.25,1.25l0,8.75l1.25,0l0,-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnalysis);
export default __webpack_public_path__ + "static/media/ico-analysis.6ada62f4cc9fb65d1ba93e2597c9383c.svg";
export { ForwardRef as ReactComponent };